<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Incident Investigation</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0">
  <mat-tab-group>
    <mat-tab label="Overview">
      <app-incidents-edit [incidentTabsComponent]="this"></app-incidents-edit>
    </mat-tab>

    <mat-tab label="LTI - Lost Time Injury" *ngIf="incident.id">
      <app-incidents-ltis [incident]="incident" (closed_incident_lti_evt)="find()"></app-incidents-ltis>
    </mat-tab>

    <mat-tab *ngIf="incident.id">
      <ng-template mat-tab-label>
        Investigation
      </ng-template>
      <app-incidents-details [incident]="incident"></app-incidents-details>
    </mat-tab>

    <mat-tab *ngIf="incident.id">
      <ng-template mat-tab-label>
        Causes / Corrective Actions
      </ng-template>
      <app-incidents-causes [incidentId]="incident.id" (incidentChange)="find()" [incidentStatus]="incident.status"></app-incidents-causes>
    </mat-tab>

    <mat-tab label="Witnesses" *ngIf="incident.id">
      <app-incidents-witnesses [incidentId]="incident.id"></app-incidents-witnesses>
    </mat-tab>

    <mat-tab label="Hazards & Risks" *ngIf="incident.id">
      <app-incidents-hazards [incidentId]="incident.id" [siteId]="incident.site_id"></app-incidents-hazards>
    </mat-tab>

    <mat-tab label="Assets" *ngIf="incident.id">
      <app-incidents-view-assets [incidentId]="incident.id" [siteId]="incident.site_id"></app-incidents-view-assets>
    </mat-tab>

    <mat-tab label="Notes" *ngIf="incident.id">
      <app-incidents-notes [incidentId]="incident.id" [incidentStatus]="incident.status"> </app-incidents-notes>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
